/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "fab617b20639b9298b1232d55f6097d390137b92";
